import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryEntries from '@/pages/home/components/CategoryEntries';
import MovieSection from '@/pages/home/components/MovieSection';
import RankingList from '@/pages/home/components/RankingList';
import SiteIntro from '@/pages/home/components/SiteIntro';
import SectionHeading from '@/components/base/SectionHeading';
import { useSeo } from '@/hooks/useSeo';
import { homeSeo } from '@/mocks/movies';
import { getHotMovies, getLatestMovies } from '@/utils/movies';

export default function Home() {
  useSeo({
    title: homeSeo.title,
    description: homeSeo.description,
    keywords: homeSeo.keywords,
  });

  const latest = getLatestMovies(8);
  const hot = getHotMovies(5);

  return (
    <>
      <HeroCarousel />
      <CategoryEntries />

      <MovieSection
        title="最新上线"
        subtitle="按更新时间排序，抢先看新片新剧"
        moreTo="/category/movie/list?sort=latest"
        movies={latest}
      />

      <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-100/60">
        <SectionHeading title="本周热播榜" subtitle="按播放量排行的热门影视" moreTo="/category/tv/list?sort=hot" />
        <RankingList movies={hot} />
      </section>

      <MovieSection
        title="热门推荐"
        subtitle="口碑与人气兼具，值得一看"
        moreTo="/category/movie/list?sort=rating"
        movies={getHotMovies(8)}
      />

      <SiteIntro />
    </>
  );
}